// blogData.js
const blogPosts = [
    {
      id: 1,
      title: "blog.1.title",
    short: "blog.1.short",
    content: "blog.1.content",
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/seferihisar-yat-temizligi.jpg"
    },
    {
      id: 2,
      title: "blog.2.title2",
    short: "blog.2.short2",
    content: "blog.2.content2",
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/hakkimizda-scaled.jpg"
    },
    {
        id: 3,
        title: "blog.3.title3",
    short: "blog.3.short3",
    content: "blog.3.content3",
        image: "https://www.remora.com.tr/wp-content/uploads/2025/05/17.jpg"
      },
      {
        id: 4,
        title: "blog.4.title4",
        short: "blog.4.short4",
        content: "blog.4.content4",
        image: "https://www.remora.com.tr/wp-content/uploads/2025/05/Deniz_Restorasyonu_2.jpg"
      },
      {
        id: 5,
        title: "blog.5.title5",
        short: "blog.5.short5",
        content: "blog.5.content5",
        image: "https://www.remora.com.tr/wp-content/uploads/2025/05/indir.jpeg"
      },
    // Diğer yazılar...
  ];
  
  export default blogPosts;
  